<template>
  <div>
    <div>
      <el-card class="box-card" v-for="(item,index) in formData" :key="index">
        <div slot="header" class="clearfix">
          <span>{{item.name}}</span>
          <span>{{item.phone}}</span>
          <el-button type="danger" size="mini" :class="item.type=='患者'?'red':'purple'">{{item.type}}</el-button>
          <el-button type="primary" size="mini">{{item.flat}}</el-button>
          <span class="waitTime">等待时间:{{item.waitTime}}</span>
        </div>
        <div class="formList">
          <div class="formItem">
            <div>预检台:{{item.name}}</div>
            <div>预检台接待时间:{{item.time}}</div>
          </div>

          <div class="formItem">
            <div>前台:{{item.name}}</div>
            <div>前台接待时间:{{item.time}}</div>
          </div>

          <div class="formItem">
            <div>客服:{{item.name}}</div>
            <div>客服接待时间:{{item.time}}</div>
          </div>

          <div class="formItem">
            <div>护士:{{item.name}}</div>
            <div>护士接待时间:{{item.time}}</div>
          </div>

          <div class="formItem">
            <div>技师:{{item.name}}</div>
            <div>技师接待时间:{{item.time}}</div>
          </div>

          <div class="formItem">诊室号:</div>
          <div>
            <div>
              <el-button type="primary" size="mini">移交前台</el-button>
              <el-button type="primary" size="mini">详情</el-button>
            </div>
            <el-button type="primary" size="mini">关联陪同</el-button>
          </div>
        </div>
      </el-card>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: [
        {
          name: '张三',
          phone: '15245487896',
          type: '患者',
          flat: '预检台',
          time: "2022-08-18 09:27:56",
          waitTime: '未开始'
        },
        {
          name: '李四',
          phone: '15245487896',
          type: '患者',
          flat: '预检台',
          time: "2022-08-18 09:27:56",
          waitTime: '未开始'
        },
        {
          name: '刘哈',
          phone: '15245487896',
          type: '陪同',
          flat: '预检台',
          time: "2022-08-18 09:27:56",
          waitTime: '未开始'
        },
      ]

    }
  }

}
</script>
<style scoped>
.formItem {
  /* border: 1px solid red; */
  flex: 1;
  font-size: 14px;
}
.formList {
  display: flex;
}
.box-card {
  margin-bottom: 15px;
}
.red {
  background: red;
}
.purple {
  background: rgb(0, 38, 255);
}
.waitTime {
  font-size: 14px;
  margin-left: 10px;
}
</style>